import lcscDecrypt from './lcsc-decrypt';
import lcscEncrypt from './lcsc-encrypt';

export default function transformData(res, type, needCryptoFields) {
  if (Object.prototype.toString.call(res) === '[object String]') {
    if (type === 'DECRYPT') {
      return lcscDecrypt(res);
    }
    // 加密
    return lcscEncrypt(res);
  }
  if (Object.prototype.toString.call(res) === '[object Array]') {
    // TODO: 递归 加解密
    return res.map((item) => {
      return transformData(item, type, needCryptoFields);
    });
  }
  if (Object.prototype.toString.call(res) === '[object Object]') {
    // TODO: 递归 加解密
    Object.keys(res).map((key) => {
      if (!res[key]) {
        // 为空直接返回
        return res;
      }
      if (Object.prototype.toString.call(res[key]) !== '[object String]') {
        res[key] = transformData(res[key], type, needCryptoFields);
      } else {
        if (Array.isArray(needCryptoFields) && needCryptoFields.some((t) => t === key)) {
          // 需要加解密的字段
          res[key] = transformData(res[key], type, needCryptoFields);
        }
      }
    });
    return res;
  }
  // 无需加解密 直接返回
  return res;
}
